import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface BootstrapConfirmDialogProps {
  open: boolean;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BootstrapConfirmDialog: React.FC<BootstrapConfirmDialogProps> = ({
  open,
  isPending,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (!value && !isPending) onCancel();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("regions.bootstrap.confirmTitle")}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">
            {t("regions.bootstrap.confirmDescription")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="new_ghost"
            onClick={onCancel}
            disabled={isPending}
          >
            {t("regions.bootstrap.cancel")}
          </Button>
          <Button
            type="button"
            variant="new_destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? <Loader2 className="size-4 animate-spin" /> : null}
            {isPending
              ? t("regions.bootstrap.running")
              : t("regions.bootstrap.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
